import SharePointStats from '../components/SharePoint/SharePointStats';
import SharePointReport from '../components/SharePoint/SharePointReport';
import ETLStats from '../components/SharePoint/ETLStats';

import DashboardIcon from '@mui/icons-material/Dashboard';
import SecurityIcon from '@mui/icons-material/Security';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ShareIcon from '@mui/icons-material/Share';
import StorageIcon from '@mui/icons-material/Storage';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupIcon from '@mui/icons-material/Group';
import SyncIcon from '@mui/icons-material/Sync';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SearchIcon from '@mui/icons-material/Search';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

export const SECTIONS = [
  { 
    id: 'overview', 
    label: 'Overview', 
    icon: <DashboardIcon />,
    path: '/'
  },
  {
    id: 'etl-stats',
    label: 'ETL Stats',
    icon: <SyncIcon />,
    path: '/etl-stats'
  },
  {
    id: 'storage-growth',
    label: 'Storage Growth',
    icon: <TrendingUpIcon />,
    path: '/storage-growth'
  },
];

export const MENU_ITEMS = {
  reports: {
    id: 'reports',
    label: 'Reports',
    icon: <AssessmentIcon />,
    items: [
      { id: 'external-sharing', label: 'External Sharing Risks', icon: <ShareIcon />, path: '/external-sharing-report' },
      { id: 'security-audit', label: 'Security Audit Report', icon: <SecurityIcon />, path: '/security-audit-report-dw' },
      { id: 'security-lookup', label: 'Security Lookup', icon: <SearchIcon />, path: '/security-lookup' },
      { id: 'file-management', label: 'File Management', icon: <StorageIcon />, path: '/file-management' },
      { id: 'file-usage', label: 'File Usage Report', icon: <StorageIcon />, path: '/file-usage-report' }
    ]
  },
  configuration: {
    id: 'configuration',
    label: 'Configuration',
    icon: <SettingsIcon />,
    items: [
      { id: 'sharepoint', label: 'My SharePoint Configuration', icon: <SettingsIcon />, path: '/sharepoint-config' },
      { id: 'users', label: 'User Management', icon: <GroupIcon />, path: '/user-management', roles: ['System Admin'] },
      { id: 'etl-ops', label: 'ETL Operations', icon: <SyncIcon />, path: '/admin/etl-operations', roles: ['System Admin'] },
      { id: 'etl-monitor', label: 'ETL Monitor', icon: <StorageIcon />, path: '/etl-monitor' }
    ]
  }
}; 